import axios from 'axios';
import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';

import type { JobDetails } from '../components';
import {
  type Actions,
  type State,
  getSelectedQuestions,
  getVersionNumber,
  setQuestions,
  showQuestions,
} from '../components/App/state';
import { useConfig } from '../components/Config/ConfigProvider';
import { createRecommendations } from '../sdk';

export const useGenerateNewRecommendationsOnChange = (
  questionnaireId: string,
  stateLoaded: boolean,
  state: State,
  dispatch: React.Dispatch<Actions>,
  jobDetails?: JobDetails,
): void => {
  const { country } = useConfig();
  const selectedQuestions = getSelectedQuestions(state);
  const [, setState] = useState(); // https://github.com/facebook/react/issues/14981#issuecomment-468460187
  const hackObjToSilenceTestErrors = {};

  useDeepCompareEffect(() => {
    if (state.published) {
      return;
    }

    if (jobDetails && stateLoaded) {
      const source = axios.CancelToken.source();

      const generateRecommendations = async () => {
        try {
          const response = await createRecommendations(
            {
              id: questionnaireId,
              jobDetails,
              country,
              ...selectedQuestions,
              versionNumber: getVersionNumber(state),
            },
            source.token,
          );

          dispatch(setQuestions(response));
          dispatch(showQuestions());
        } catch (error) {
          setState(() => {
            throw error;
          });
        }
      };

      generateRecommendations();

      return () => {
        source.cancel('Cleanup');
      };
    }
  }, [questionnaireId, jobDetails, stateLoaded, hackObjToSilenceTestErrors]);
};
